import {
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';
import { useWidgetContext } from '../../context/WidgetContext';
import { useRegisterHotjarPage } from '../../hooks';
import { PageFields_CancelledPage_Fragment as PaymentCanceledPageFields } from '../../graphql/generated';

interface PaymentUnavailableProps {
  className?: string;
  data: PaymentCanceledPageFields['cancelledPageData'];
}

export default function PaymentUnavailable({
  data,
}: PaymentUnavailableProps): JSX.Element {
  useRegisterHotjarPage('payment-unavailable');

  const { configureHeader } = useWidgetContext();

  const merchantName = data?.merchantName || '';

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: merchantName || '',
      billType: data?.billType,
    });
  }, [configureHeader, merchantName, data?.billType]);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="error">
            <WidgetHeaderContent title="Payment unavailable" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <WidgetStatus
              emoji="😕"
              title="Payment unavailable"
              description={
                <>
                  Payments to this business are currently not possible.
                  <br />
                  You can try again later or contact the business directly if
                  you <br /> need any more information.
                </>
              }
            />
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
}
